import SupportPanel from '@/components/support/SupportPanel'
import { useParentPortalData } from './ParentHome'

export default function ParentSupport() {
  const { data } = useParentPortalData()
  const supportLine = data.parent?.name
    ? `${data.parent.name}, reach the Tower support team when you need help.`
    : 'Reach the Tower support team when you need help.'
  const primaryStudent = data.students?.[0]

  return (
    <div className="space-y-6">
      <SupportPanel
        roleLabel="Guardian"
        intro={supportLine}
        defaultCategory="parent_support"
        contextMeta={{
          surface: 'guardian_portal',
          student_id: primaryStudent?.id,
          classroom_id: primaryStudent?.classroom?.id,
          teacher_id: primaryStudent?.classroom?.teacherUserId || undefined,
        }}
      />
    </div>
  )
}
